import { render } from "./CliPaymentMethodSection.vue?vue&type=template&id=c8b47f96&ts=true"
import script from "./CliPaymentMethodSection.vue?vue&type=script&lang=ts"
export * from "./CliPaymentMethodSection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__